import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { ApiResponseBody, fetchClient, userApiClient } from '@/setup/api'

export type IGetCityQueryData = ApiResponseBody<'get', '/web/cities/{citySlug}'>['data']

export const getCityQueryOptions = (citySlug: string, locale: string) => {
    const init = {
        params: { path: { citySlug } },
        headers: { 'accept-language': locale },
    }

    return {
        queryKey: userApiClient.queryOptions('get', '/web/cities/{citySlug}', init).queryKey,
        queryFn: async ({ signal }: { signal: AbortSignal }) => {
            const { data, error, response } = await fetchClient.GET('/web/cities/{citySlug}', {
                ...init,
                signal,
            })

            if (response.status === 404) return null
            if (error) throw error

            return data ?? null
        },
    }
}

export function useGetCityQuery(citySlug: string) {
    const locale = useLocale()

    return useQuery(getCityQueryOptions(citySlug, locale))
}
